import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function SweetTofu() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Sweet Tofu</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        <b>Serves 4</b>
        <br></br>2 cups vegetable oil for frying <br></br>
        14 ounces to 1 pound firm or medium firm tofu, cut into bite size pieces
        <br></br>¼ cup potato starch <br></br>1 tablespoon pumpkin seeds
        (optional) <br></br>
        <br></br>
        <b>For seasoning sauce</b> <br></br>¼ cup ketchup <br></br>¼ cup rice
        syrup <br></br>3 tablespoons gochujang (Korean hot pepper paste)
        <br></br>
      </Typography>

      <Typography>
        Combine all the seasoning sauce ingredients in a skillet. Heat over
        medium high heat, stirring for about 1 to 2 minutes until bubbling.
        Remove from the heat and set the skillet aside. We'll reheat this just
        before serving. <br></br>
        <br></br>
        <b>Coat the tofu</b> <br></br>
        Cut the tofu into 1 x 1½ inch bite sized pieces. Pat dry with kitchen
        towel or paper towel. <br></br>
        Gently put the tofu into a plastic bag and add the potato starch. Seal
        the bag and gently turn it over until the tofu is well and evenly coated
        with the starch. <br></br>
        Remove each piece from the bag individually and transfer to a large
        plate or a cutting board lined with plastic wrap, leaving some space
        between the pieces.<br></br>
        <br></br>
        <b>Fry the tofu </b>
        <br></br>
        Heat the oil in a skillet for 5 minutes, until it reaches 330-340°F.
        Carefully add the tofu pieces one at a time to the hot oil. Turn the
        heat down to medium and let the tofu cook for about about 2 to 3
        minutes, until the bottom turns light brown and the surface is a little
        crispy .<br></br>
        Turn the tofu pieces with tongs or a slotted spoon—they should be firm
        enough to turn without breaking—and fry for another 2 to 3 minutes,
        occasionally turning so that all sides turn light brown and crispy.
        Remove from the skillet and set in a wire mesh strainer set over a bowl.
        <br></br>
        <br></br>
        <b>… and then time to double-fry!</b>
        <br></br>
        Reheat the oil for 1 minute over medium-high heat and fry all the tofu
        again for 3 to 4 minutes, rotating and turning them over with tongs or
        long wooden chopsticks, until all sides are golden brown and crunchy.
        <br></br>
        <br></br>
        <b>Handle pumpkin seeds</b>
        <br></br>
        Transfer the tofu to the strainer set over a bowl to drain the excess
        oil.<br></br>
        If you use pumpkin seeds, put them into a slotted spoon and dip them
        into the hot oil to fry them for just 10 seconds or so. Transfer the
        seeds to a small bowl and turn off the heat.<br></br>
        <br></br>
        <b>Coat and serve</b>
        <br></br>
        Reheat the sauce in the skillet until bubbling. Add the fried tofu and
        gently mix all together until they are well coated.<br></br>
        Transfer to a plate and sprinkle the pumpkin seeds over top. Serve as a
        side dish for rice.<br></br>
      </Typography>
    </Card>
  );
}
